import { reducer as appReducer } from '@/core/services/App/AppSlice'
import { reducer as walletReducer } from '@/core/services/Wallets/WalletSlice'
import { reducer as authReducer } from '@/modules/Auth/store/AuthSlice'
import { reducer as affiliateReducer } from '@/modules/Profile/Affiliate/store/AffiliateSlice'
import { reducer as ordersReducer } from '@/modules/Profile/Orders/store/OrdersSlice'
import { combineReducers } from '@reduxjs/toolkit'

const rootReducer = combineReducers({
  appReducer,
  walletReducer,
  authReducer,
  affiliateReducer,
  ordersReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
